module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7eea42371f5ccb84b4fc7d0ba7331ea3.png";